import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import Dropdown from 'components/FormFieldsSimple/Dropdown';
import DropdownMulti from 'components/FormFieldsSimple/DropdownMulti';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class DropdownField extends Component {
  static propTypes = {
    ...fieldPropTypes,
    onInputChange: PropTypes.func,
  };

  static defaultProps = {
    onInputChange: Function.prototype,
  };

  handleChange = (value) => {
    const { input } = this.props;

    input.onFocus();
    input.onChange(value);
    input.onBlur();
    this.props.onInputChange(value);
  };

  render() {
    const { input, isMulti, onFocusChange } = this.props;
    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        {isMulti ? (
          <DropdownMulti
            {...this.props}
            onChange={this.handleChange}
            value={input.value}
          />
        ) : (
          <Dropdown
            {...this.props}
            onChange={this.handleChange}
            onFocusChange={onFocusChange}
            value={input.value}
          />
        )}
      </ReduxFormElementWrapper>
    );
  }
}
